import axios from 'axios';

const baseURL = window.location.host.indexOf('localhost') >= 0 ? 'http://localhost:8080' : window.location.protocol + '//' + window.location.host

const instance = axios.create({
    baseURL
});

export default instance;
export const apiUrl = baseURL